<ng-container *ngIf="loaderService.loader">
    <div class="loader-container">
        <div class="mini-float-loader">
            <mat-spinner [diameter]="20"></mat-spinner>
            <span class="sp-title">{{ loaderService.title }}</span>
        </div>
    </div>
</ng-container>